
import router from '@/router'
import { 
    getUserInfo, 
    // setToken,
    // setUserInfo
} from '@/utils/auth'
import store from '@/store'
import { setUserStatus } from '@/utils/auth'
router.beforeEach(async (to, from, next) => {
    if (to.query.from !== undefined) {
        setUserStatus(to.query.from == 1)
    }
    /*console.log(123)
    if (to.fullPath.indexOf('xx') != -1) {
        
        next({
            name: '/NotFound'
        })
    } else {*/

        // 开发模式
        // if (process.env.NODE_ENV != 'production') {
        //     setToken('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ0aGlzIGlzIEppbmdjaSB0b2tlbiIsImF1ZCI6Ik1JTklBUFAiLCJpc3MiOiJMSVRFTUFMTCIsImV4cCI6MTY2MzU1OTQ2NiwidXNlcklkIjoxNSwiaWF0IjoxNjYzNTUyMjY2fQ.9YRJ71A2fWGGkbmmTDp-v6CyIO0S41XA_Bn0n1zxZmM')
        //     setUserInfo({"bindingMobile": "15135767481", "avatar": "https://thirdwx.qlogo.cn/mmopen/vi_32/VfrgcrYiabO32SsQl6vs6cH3mS1qPFq0zY6LNyBYSMXpgIFPKzvMaAfIAszCpMJcFlH5FjtGg6y4MttJmJ6AiaXQ/132", "username": "吃番茄的圣女果"})
        // }
        if (to.meta.needLogin === true || to.meta.needReal === true) {
            // await baseApi.checkLogin()

            if (getUserInfo().bindingMobile) {
                // 更新实名状态
                await store.dispatch('refreshRealStatus')
                // 不需要实名或已实名直接进入
                if (!to.meta.needReal || getUserInfo().status === 1) {
                  next()
                } else {
                  // 去首页，并提示实名
                  next(to.meta.realRedirect || '/')
                }
            } else {
                // 在未登陆情况下如跳转路径含登陆则继续跳转
                next({
                    path: '/login',
                    query: {
                        redirect: encodeURIComponent(to.fullPath)
                    }
                })
            }
        } else {
            next()
        }
   /* }*/
    
    if (to.meta.title) {
        document.title = to.meta.pageTitle || to.meta.title
    }

})
